import { Link } from 'react-router-dom'
import { DecorativeDivider } from '../components/DecorativeDivider'
import { DocumentMeta } from '../components/DocumentMeta'
import { PhotoPlaceholder } from '../components/PhotoPlaceholder'
import { siteContent } from '../content/siteContent'

export function HomePage() {
  return (
    <div className="home-page">
      <DocumentMeta title="Kasia Staszewska — oprawa wokalna i lekcje śpiewu" description="Oprawa wokalna ślubów oraz indywidualne lekcje śpiewu online. Poznaj ofertę Kasi Staszewskiej." path="/" />
      <section className="home-hero">
        <div className="container home-hero__grid">
          <div className="home-hero__copy">
            <div className="hero-monogram" aria-hidden="true"><span>K</span><i /><span>S</span><b>Kasia Staszewska</b></div>
            <p>{siteContent.intro}</p>
            <div className="button-row"><Link className="button button--hero" to="/oprawa-wokalna">Oprawa ślubu</Link><Link className="button button--hero" to="/lekcje-spiewu">Lekcje śpiewu</Link></div>
          </div>
          <PhotoPlaceholder label="Główne zdjęcie Kasi" imageSrc="/images/kasia-home-hero-v7.png" imageAlt="Kasia Staszewska z mikrofonem w różowej koronkowej sukience" />
        </div>
      </section>

      <section className="section about-preview" id="o-mnie" aria-labelledby="about-heading">
        <div className="container about-preview__content">
          <h2 id="about-heading">O MNIE</h2>
          <DecorativeDivider />
          <div className="about-preview__copy">
            <p>Nazywam się Kasia Staszewska. Jestem wokalistką oraz certyfikowaną trenerką wokalną.</p>
            <p>Śpiew jest moją pasją, a największą satysfakcję daje mi możliwość dzielenia się nią z innymi. Na co dzień pomagam wokalistom i osobom, które po prostu kochają śpiewać, rozwijać swoje głosy, nabierać pewności siebie i czerpać z muzyki jeszcze więcej radości. Uwielbiam obserwować postępy moich uczniów i towarzyszyć im w drodze do odkrywania możliwości własnego głosu.</p>
            <p>Od 2016 roku prowadzę również muzyczny kanał na YouTube, gdzie publikuję zagraniczne piosenki w autorskich polskich wersjach. Moje filmy osiągnęły łącznie ponad 60 milionów wyświetleń, a „Kasia Staszewska Music” należy dziś do najpopularniejszych polskich kanałów muzycznych na YouTube.</p>
          </div>
        </div>
      </section>
    </div>
  )
}
